import { useAccountRepository } from '@frontend/repository';
import { FormattedMessage } from 'react-intl';

import { Dashboard, DashboardCard } from '../../../statistics/shared';
import { Last6MonthsVendingPackageVolumeWeekdayHeatmapChart } from '../../../statistics/vending/last-6-months-vending-package-volume-weekday-heatmap-chart/last-6-months-vending-package-volume-weekday-heatmap-chart.component';
import { Last30DaysVendingPackageVolumeByProductListChart } from '../../../statistics/vending/last-30-days-vending-consumption-rate-by-product-list-chart/last-30-days-vending-consumption-rate-by-product-list-chart.component';
import { Last30DaysVendingPackageVolumeLineChart } from '../../../statistics/vending/last-30-days-vending-package-volume-line-chart/last-30-days-vending-package-volume-line-chart.component';
import { Last60DaysVendingHighestRiserMetricCard } from '../../../statistics/vending/last-60-days-vending-highest-riser-metric-card/last-60-days-vending-highest-riser-metric-card.component';
import { Last60DaysVendingLowestFallerMetricCard } from '../../../statistics/vending/last-60-days-vending-lowest-faller-metric-card/last-60-days-vending-lowest-faller-metric-card.component';
import { useLast60DaysVendingProductPopularity } from '../../../statistics/vending/use-last-60-days-vending-product-popularity';
import { VendingProductsNeedingRefillListCard } from '../../../statistics/vending/vending-products-needing-refill-list-card/vending-products-needing-refill-list-card.component';
import OverviewHeader from '../../header/overview-header';

const VendingProductPopularityMetricCards = ({ accountId }: { accountId: string }) => {
    const { highestRiser, lowestFaller, isLoading } = useLast60DaysVendingProductPopularity(accountId);

    return (
        <>
            <DashboardCard size='2x1'>
                <Last60DaysVendingHighestRiserMetricCard
                    item={highestRiser}
                    isLoading={isLoading}
                />
            </DashboardCard>
            <DashboardCard size='2x1'>
                <Last60DaysVendingLowestFallerMetricCard
                    item={lowestFaller}
                    isLoading={isLoading}
                />
            </DashboardCard>
        </>
    );
};

const VendingDashboard = () => {
    const { currentAccount } = useAccountRepository();

    return (
        <div
            key='vending-dashboard'
            className='bg-background-default flex w-full flex-col items-start justify-start gap-6 self-stretch'>
            <OverviewHeader
                title={
                    <FormattedMessage
                        id='vending-dashboard.title'
                        defaultMessage='Vending / Dashboard'
                    />
                }
            />
            <Dashboard>
                <DashboardCard size='3x2'>
                    <VendingProductsNeedingRefillListCard accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='3x2'>
                    <Last30DaysVendingPackageVolumeByProductListChart accountId={currentAccount} />
                </DashboardCard>
                <VendingProductPopularityMetricCards accountId={currentAccount} />
                <DashboardCard size='3x2'>
                    <Last6MonthsVendingPackageVolumeWeekdayHeatmapChart accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='3x2'>
                    <Last30DaysVendingPackageVolumeLineChart accountId={currentAccount} />
                </DashboardCard>
            </Dashboard>
        </div>
    );
};

export default VendingDashboard;
